import React from 'react'
import { Link } from "react-router-dom"
import { companyList } from '../../../api/requests/company/CompanyRequest'
import { brandList } from '../../../api/requests/brand/BrandRequest'
import ActionBadge from '../../helpers/ActionBadge'
import LoadingOverlay from 'react-loading-overlay'
import { TEXT as text } from '../../../helpers/text/Inbox'
function AlertList() {
    document.title = text.document
    let [loading, setLoading] = React.useState(false);
    const [company, setCompany] = React.useState([])
    React.useEffect(() => {
        const data = async () => {
            setLoading(true)
            const result = await brandList()
            if (result) {
                setTimeout(() => {
                    setLoading(false)
                }, 800)
            }
            setCompany(result.data)
        }
        data()
    }, [])

    return(
        <>
            <LoadingOverlay active={loading} spinner text={text.inbox_loading}>
                <div style={{minHeight:90+'vh'}}>
                    <header className="page-header">
                        <div className="d-flex align-items-center">
                            <div className="mr-auto">
                                <h1 className="separator">
                                    {text.page_title}
                                </h1>
                                <nav className="breadcrumb-wrapper" aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                <i className="icon dripicons-home"></i>
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/brand/list">
                                                <u>Brand List</u>
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/brand/search">
                                                Search Brand
                                            </Link>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </header>
                    <section className="page-content container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <h5 className="card-header">Brand List</h5>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Name</th>
                                                        <th>Brand Code</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                {company ? company.map((data) => (
                                                    <tr key={data._id}>
                                                        <td>{data.brand_id}</td>
                                                        <td>{data.brand_name}</td>
                                                        <td>{data.brand_code}</td>
                                                        <td>
                                                            {data.deleted == 0 ? (
                                                                <span class="badge badge-pill badge-success">Active</span>
                                                            ) : (
                                                                <span class="badge badge-pill badge-danger">Inactive</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <ActionBadge type="view" page="Brand" />
                                                        </td>
                                                    </tr>
                                                )) : 'Alert Not Found'}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </LoadingOverlay>
        </>
    )
}

export default AlertList